
import React, { Component } from 'react';
import Barcode from 'react-barcode';
import Image from './../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../utils/clientConstant';
import Favourite from '../../../../../components/ZUILib/Favourite';


export default class DownloadableFile extends Component {
  render() {
    const { labels } = this.props;
    let pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.liverpool.label');
    if (commonUtil.getBrand() === defaultConst.constBrand.PB) {
      pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.pb.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.PBK) {
      pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.pbk.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.GAP) {
      pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.gap.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WLM) {
      pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.wlm.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.WS) {
      pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.ws.label');
    } else if (commonUtil.getBrand() === defaultConst.constBrand.TRU) {
      pdfBrandMessage = commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.exclusive.product.tru.label');
    }
    const categoryItemInfo = (itemData, index, categoryName) => {
      const productImageSrc = [
        {
          media: '(max-width: 465px)',
          srcSet: itemData.imageURL,
        },
      ];
      if (categoryName === commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label')) {
        this.defaultImage = commonUtil.getAssetURL() + '/images/certificado.jpg';
      } else {
        this.defaultImage = commonUtil.getAssetURL() + '/images/guest/no-image.png';
      }

      const productImageAttribute = {
        id: 'img1',
        alt: 'Liverpool',
        src: itemData.imageURL,
        altImg: this.defaultImage,
        // height: '88px',
        pictureHtmlStyle: {
          alignPicture: 'center',
        }
      };


      const productPrice = commonUtil.getCurrency(itemData.salePrice);

      let deliverAddressNickName = '';
      if (!commonUtil.isObjectEmpty(this.props.registeredGiftList) && this.props.registeredGiftList.deliveryAddressInfo.length > 1) {
        this.props.registeredGiftList.deliveryAddressInfo.forEach((p1) => {
          if (p1.deliveryAddressId === itemData.addressId) {
            deliverAddressNickName = p1.deliveryAddressName;
          }
        });
      } else if (itemData.deliveryMode === 'physical') {
        !commonUtil.isObjectEmpty(this.props.registeredGiftList) && this.props.registeredGiftList.deliveryAddressInfo.length > 0 && this.props.registeredGiftList.deliveryAddressInfo.forEach((p1) => {
          if (p1.deliveryAddressId === itemData.addressId) {
            deliverAddressNickName = p1.deliveryAddressName;
          }
        });
        //deliverAddressNickName = this.props.registeredGiftList.deliveryAddressInfo[0].deliveryOwnerName;
      }

      return (
        // <tr>
        //   <td style={{ width: '5%' }}>
        //     <div className="div_star">{itemData.isFavourite ? <i className="icon-estrella_negativo flag" /> : ''}</div>
        //   </td>
        //   <td className="text-left p-r-20" style={{ width: '15%' }}>
        //     <div className="productContent" style={{ height: '88px' }}><Image imageAttr={productImageAttribute} _imgsrc={productImageSrc} key={index} /></div>
        //   </td>
        //   <td className="imgInner p-l-40" style={{ width: '40%' }}>

        //     <div >
        //       <p><b>{itemData.name}<br /><span className="sku">{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.SKU.label')}: {itemData.skuId}</span></b></p>
        //     </div>
        //   </td>
        //   <td style={{ width: '20%' }}>
        //     <p className="text-center"><b>{productPrice}</b></p>
        //   </td>
        //   <td style={{ width: '20%' }}>
        //     <p className="text-center"><b>{itemData.quantity}</b></p>
        //   </td>
        // </tr>
        <tr index={index}>
          <td className="text-center" style={{ width: '5%' }}>
            <Favourite id={itemData.skuId} disabled="true" item={itemData} checked={itemData.isFavourite} />
          </td>
          <td className="" style={{ width: '10%', height: '88px' }}>
            <Image imageAttr={productImageAttribute} _imgsrc={productImageSrc} />
          </td>
          <td className="" style={{ width: '20%', textAlign: 'left' }}>
            <div className="textToBold"><b>{itemData.name}</b></div>
            <div className="sku">{commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosregistrados.sku.label')}: {itemData.skuId}</div>
          </td>
          <td className="priceAndQuant priceInner" style={{ width: '8%' }}>
            <div className="textToBold text-center"><b>{productPrice}</b></div>
          </td>
          <td className="priceAndQuant quantityInnerEG" style={{ width: '7%' }}>
            <div className="btn-group text-center"><span className="textToBold"><b>{itemData.quantity}</b></span></div>
          </td>
          {/* <td className="priceAndQuant disponibilityInner" style={{ width: '7%' }}>
          {(itemData.availability === 'true' || itemData.availability) ? <div className="textGreen">{commonUtil.getLabel(labels.RegalosRegistradosPage, 'regalosregistrados.inventory.displonsible.label')}</div> : <div className="textRed">{commonUtil.getLabel(labels.RegalosRegistradosPage, 'regalosregistrados.inventory.nodisplonsible.label')}&nbsp;&nbsp;</div>}
        </td>
        <td className="text-center addressInner" style={{ width: '19%' }}>
          {deliverAddressNickName}
        </td>
        <td className="modeGiftInner" style={{ width: '23%' }}>{itemData.deliveryMode === 'physical' ? commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.physical.label') : commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.electronic.label') }</td> */}
        </tr>


      );
    };
    const giftListTable = giftItems => (
      <React.Fragment>
        {/* <div className="row">
          <div className="col-xs-12">
            {giftItems.categoryName === commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label') ?
              <p className="label_categoria">{commonUtil.getLabel(labels.GuestviewPage, 'guestview.category.label')}: <b>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label')}</b>
                <span className="nota pull-right">*{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.the.certifcates.are.by.default.label')}</span> </p> : <p className="label_categoria">{commonUtil.getLabel(labels.GuestviewPage, 'guestview.category.label')}: <b>{giftItems.categoryName}</b> </p>}

          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 contentTable">
            <table className="cTable bottomLine">
              <thead className="rowLines">
                <tr>
                  <td style={{ width: '5%' }} />
                  <td className="text-left" style={{ width: '15%' }} />
                  <td className="text-center" style={{ width: '40%' }}><a href>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.article.label')}</a></td>
                  <td className="text-center" style={{ width: '20%' }}><a href>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.price.label')}</a></td>
                  <td className="text-center" style={{ width: '20%' }}><a href>{commonUtil.getLabel(labels.GuestviewPopupPage, 'guestviewpopup.quantity.label')}</a></td>
                </tr>
              </thead>
              <tbody>

                {giftItems.itemInfo.map((categoryItem, index) =>
                categoryItemInfo(categoryItem, index, giftItems.categoryName))}
              </tbody>
            </table>
          </div>
        </div> */}
        <div className="row">
          <div className="col-xs-12">
            {giftItems.categoryName === commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label') ?
              <p className="label_categoria">{commonUtil.getLabel(labels.GuestviewPage, 'guestview.category.label')}: <b>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.gift.certificate.name.label')}</b>
                <span className="nota pull-right">*{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.the.certifcates.are.by.default.label')}</span> </p> : <p className="label_categoria">{commonUtil.getLabel(labels.GuestviewPage, 'guestview.category.label')}: <b>{giftItems.categoryName}</b> </p>}

          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 contentTable">
            <table className="tableResults">
              <thead className="rowLines">
                <tr>
                  <td >&nbsp;</td>
                  <td className="text-center" />
                  <td className="text-left" style={{ textAlign: 'center' }}>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.articles.label')}</td>
                  <td className="text-center">
                    <a>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.price.label')}
                    </a>
                  </td>
                  <td className="text-center" style={{ width: '14%' }}>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.quantity.label')}</td>
                  {/* <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosregistrados.itemavailable.label')}</td>
                  <td className="text-center" >{commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosregistrados.address.label')}</td>
                  <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosregistrados.deliverymode.label')}</td> */}
                </tr>
              </thead>
              <tbody>
                {giftItems.itemInfo.map((categoryItem, index) =>
                  categoryItemInfo(categoryItem, index, giftItems.categoryName))}
              </tbody>
            </table>
          </div>
        </div>
      </React.Fragment>
    );


    return (
      <div className="container padding-left-0">
        <div className="row info">
          <div className="col-xs-9 col-sm-9 col-md-9 names">
            <h4>
              <p><b>{this.props.eventName}</b></p>
            </h4>
            <p><b className="label-liverpool-exclusive">{pdfBrandMessage}</b></p>
          </div>
          <div className="col-xs-3 col-sm-3 col-md-3 event barcode-content">
            <p> <b>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.dateofevent.label')}:</b><span>{this.props.eventDate}</span></p>
            <p> <b>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.eventtype.label')}: </b><span>{this.props.eventType}</span></p>
            <p> <b>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.eventnumber.label')}: </b><span>{this.props.eventId}</span></p><br />
            <Barcode value={this.props.eventId} format="CODE128" width={1} height={15} textAlign="center" fontSize={11} renderer="img" />

          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <p><span className="pull-right"><b>{this.props.itemsCount}</b> {commonUtil.getLabel(labels.GuestviewPage, 'guestview.pdf.articles.label')}</span></p>
          </div>
        </div>
        {this.props.categoryItemsInfo ? this.props.categoryItemsInfo.map(giftListTable) : ''}
      </div>
    );
  }
}
